module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/1.png?4d9a97d9eca0276530e8e5d029ae3a3e";